'use client';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/navigation';
import './Banner.css';

const bannerimage = [
  // { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_1.webp', alt: 'HDNA Aarogyam Hospital Front Banner - Image 1' },
  { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/bannernew_1.webp', alt: 'HDNA Aarogyam Hospital Front Banner - Image 1' },
  { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_2.webp', alt: 'Hospital Facilities Overview Banner - HDNA Aarogyam Hospital' },
  { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_3.webp', alt: 'HDNA Aarogyam Hospital Infrastructure Banner - Image 3' },
  { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_4.webp', alt: 'Medical Equipment & ICU Banner - HDNA Aarogyam Hospital' },
  // { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_5.webp', alt: 'Expert Doctors at HDNA Aarogyam Hospital - Banner 5' },
  { image: 'https://cdn.dotplus.in/Cloud/Aarogyam/banner/aarogyam_new_banner/banner_6.webp', alt: 'Advanced Medical Services Banner - HDNA Aarogyam Hospital' }
];

const mobilebanner = [
  // { image: '/images/mob-banner/Aarogyammobilebanner-01.webp', alt: 'Expert Doctors at HDNA Aarogyam Hospital' },
  { image: '/images/mob-banner/Aarogyammobilebanner-01.webp', alt: 'HDNA Aarogyam Hospital Front Banner' },
  { image: '/images/mob-banner/Aarogyammobilebanner-04.webp', alt: 'HDNA Aarogyam Hospital Infrastructure Banner' },
  { image: '/images/mob-banner/Aarogyammobilebanner-02.webp', alt: 'Medical Equipment & ICU Banner - HDNA Aarogyam Hospital' },
];

const bannerdepartments = [
  { icon: '/images/banner-dept-icon/cardiac.webp', top: 'Cardiac', bottom: 'Sciences', alt: 'Cardiology Specialty Icon - HDNA Aarogyam Hospital' },
  { icon: '/images/banner-dept-icon/renal.webp', top: 'Renal Science', bottom: '& Transplant', alt: 'Renal Medicine Icon - HDNA Aarogyam Hospital' },
  { icon: '/images/banner-dept-icon/neurology.webp', top: 'Neuro', bottom: 'Science', alt: 'Neurology Specialty Icon - HDNA Aarogyam Hospital' },
  { icon: '/images/banner-dept-icon/anesthesia.webp', top: 'Anesthesia &', bottom: 'Critical Care', alt: 'Anesthesia Services Icon - HDNA Aarogyam Hospital' },
  { icon: '/images/banner-dept-icon/internal_medicine.webp', top: 'Internal', bottom: 'Medicine', alt: 'Internal Medicine Icon - HDNA Aarogyam Hospital' },
  { icon: '/images/banner-dept-icon/orthopedics.webp', top: 'Orthopedics &', bottom: 'Joint', alt: 'Orthopedic Care Icon - HDNA Aarogyam Hospital' },
];

const Banner = () => {
  return (
    <section className="banner-section">
      <div className="container-fluid">
        <div className="row">
          {/* Left Side Icons */}
          <div className="col-lg-3 left-side-banner-css d-flex justify-content-center align-items-center">
            <div className="d-flex flex-wrap justify-content-center align-items-center w-100 gap-css-leftsection">
              {bannerdepartments.map((item, index) => (
                <div className="dept-box-wrapper" key={index}>
                  <div className="banner-dept-box d-flex flex-column align-items-center justify-content-center text-center">
                    <Image
                      src={item.icon}
                      alt={item.alt}
                      width={60}
                      height={60}
                      priority
                      className="dept-img-banner-css"
                    />
                    <div className="mt-2 css-dept-name-leftbanner">
                      {item.top}<br />{item.bottom}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side Slider */}
          <div className="col-lg-9 col-12 p-0">
            {/* Desktop Slider */}
            <div className="d-none d-md-block">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                speed={1000}
                loop={true}
                className="banner-swiper"
              >
                {bannerimage.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="banner-image-wrapper">
                      <Image
                        src={item.image}
                        alt={item.alt}
                        width={1500}
                        height={687}
                        style={{
                          objectFit: 'cover',
                          width: '100%',
                          height: 'auto',
                        }}
                        priority={index === 0}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* Mobile Slider */}
            <div className="d-block d-md-none">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                speed={1000}
                loop={true}
                className="banner-swiper"
              >
                {mobilebanner.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="banner-image-wrapper">
                      <Image
                        src={item.image}
                        alt={item.alt}
                        width={500}
                        height={500}
                        style={{
                          objectFit: 'cover',
                          width: '100%',
                          height: 'auto',
                        }}
                        priority={index === 0}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

          </div>
          {/* <div className="col-lg-9 col-12 p-0">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              speed={1000}
              loop={true}
              initialSlide={0}
              className="banner-swiper"
            >
              {bannerimage.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="banner-image-wrapper">
                    //Desktop Image
                    <div className="desktop-image">
                      <Image
                        src={item.image}
                        alt={item.alt}
                        width={1500}  // original width
                        height={687} // original height
                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                        priority={index === 0}
                      />
                    </div>

                    //Mobile Image 
                    <div className="mobile-image">
                      <Image
                        src={mobilebanner[index % mobilebanner.length].image}
                        alt={mobilebanner[index % mobilebanner.length].alt}
                        width={500}  // original width
                        height={500} // original height
                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                        priority={index === 0}
                      />

                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Banner;
